import { Tooltip } from 'antd';
import { Button } from '@mui/material';

const UpdateButton = ({ title, type = 'submit', disabled }) => {
	return (
		<Tooltip title={title}>
			<Button
				type={type}
				disabled={disabled}
				variant="contained"
				sx={{
					minWidth: '110px',
					height: '36px',
					px: 2,
					borderRadius: '10px',
					fontSize: '14px',
					fontWeight: 500,
					lineHeight: '20px',
					textTransform: 'none',
					boxShadow: 'none',
					color: '#FFFFFF',
					bgcolor: '#155DFC',
					transition: 'all 0.2s ease',
					'&:hover': {
						bgcolor: disabled ? '#155DFC' : '#0F4CD6',
						boxShadow: 'none',
					},
					'&.Mui-disabled': {
						color: '#101828',
						backgroundColor: '#F3F4F6',
					},
				}}
			>
				{title}
			</Button>
		</Tooltip>
	);
};

export default UpdateButton;
